@if (loading) {
  <loading class="tw-absolute tw-top-1/2 tw-left-1/2 -tw-translate-x-1/2 -tw-translate-y-1/2"></loading>
}
@if (!loading) {
  @if (shouldShowFinasterideConsent) {
    <div id="finasterideConsentUI" class="tw-h-full tw-bg-gray-100 tw-font-body tw-flex tw-flex-col">
      <div class="tw-flex tw-items-center tw-gap-3 tw-px-4 tw-py-6 tw-mt-3 tw-mx-3 tw-flex-shrink-0">
        <img class="tw-h-10 tw-w-10 tw-rounded-full" src="/assets/gifs/instruction-reminder.gif" alt="loader"/>
        <p class="tw-text-400 tw-font-bold tw-text-teal-500" i18n="@@weHaveReceivedYourOrder"> We have received <br/> your order</p>
      </div>
      <div class="tw-flex-1 tw-px-3 tw-mt-2.5 tw-overflow-hidden">
        <div class="tw-flex tw-flex-col tw-h-full tw-bg-white tw-rounded-tl-6 tw-rounded-tr-6">
          <div class="tw-flex tw-items-center tw-gap-2 tw-flex-shrink-0 tw-bg-orange-100 tw-px-[18px] tw-py-3 tw-rounded-tl-6 tw-rounded-tr-6">
            @if (allocatedDoctor?.DoctorImageThumbnail) {
              <img class="tw-w-6 tw-h-6 tw-rounded-full tw-object-contain"
                [src]="allocatedDoctor.doctorDisplayImage"
                alt="Doctor Image" />
            } @else {
              <img class="tw-w-6 tw-h-6 tw-rounded-full tw-object-contain"
                src="/assets/images/dr-charu.png"
                alt="Dr Charu" />
            }
            <p class="tw-font-bold tw-text-200 tw-text-gray-800" i18n="@@informationAboutYourTreatment">Information about your treatment</p>
          </div>
          <div class="tw-flex-1 tw-overflow-y-auto tw-pt-5 tw-pl-3 tw-pr-2 tw-text-200 tw-text-gray-800">
            <div class="tw-pr-[29px]">
              <p i18n="@@congratulationsOnStart"> Hi {{ userFirstName }}, congratulations on starting your personalised hair-fall treatment with Cure! </p>
              <br />
              <p i18n="@@yourTreatmentIncludes"> <span class="tw-font-bold"> Your treatment includes Finasteride</span>, an FDA-approved oral medication that targets DHT - the hormone responsible for male pattern hair loss. It is: </p>
            </div>
            <div class="tw-flex tw-items-center tw-gap-1.5 tw-mt-2">
              <img class="tw-w-4 tw-h-4" src="/assets/icons/orange-check-circle.svg" alt="check"/>
              <p i18n="@@clinicallyProven"> <span class="tw-font-bold"> Clinically proven </span> to reduce hair fall and preserve existing hair.</p>
            </div>
            <div class="tw-flex tw-items-center tw-gap-1.5 tw-mt-2">
              <img class="tw-w-4 tw-h-4" src="/assets/icons/orange-check-circle.svg" alt="check"/>
              <p i18n="@@effectiveIn36Months"> <span class="tw-font-bold"> Effective in 3-6 months </span> with daily use, with visible improvements seen by most users </p>
            </div>
            <div class="tw-flex tw-items-center tw-gap-1.5 tw-mt-2">
              <img class="tw-w-4 tw-h-4" src="/assets/icons/orange-check-circle.svg" alt="check"/>
              <p i18n="@@safeWithRareSideEffects"> <span class="tw-font-bold"> Safe, </span> with rare and temporary side effects (e.g., reduced libido, mood changes in < 2% cases) </p>
            </div>
            <div class="tw-flex tw-items-center tw-gap-1.5 tw-bg-[#D9D9D9] tw-pl-[18px] tw-pr-8 tw-py-3 tw-mt-3 tw-mr-1 tw-rounded-1">
              <p i18n="@@importantPregnantWomen"> <span class="tw-font-bold"> Important: Pregnant women </span> should not handle broken or crushed tablets. </p>
            </div>
            <div class="tw-mt-3 tw-pl-[21px] tw-pr-1">
              <p i18n="@@yourDoctorPrescribed"> Your doctor has prescribed it based on your hair-fall stage and long-term goals. </p>
              <p class="tw-pt-4" i18n="@@forAnyConcernsContactUs"> For any concerns, contact us via the <span class="tw-font-bold"> “Help” section </span> in the app—we’re here to support you throughout! </p>
            </div>
          </div>
        </div>
      </div>
      <div class="tw-w-full tw-h-[100px] tw-bg-white tw-px-4 tw-pt-5 tw-pb-10 tw-flex-shrink-0">
        <button class="tw-rounded-2 tw-bg-teal-600 tw-text-white tw-font-body tw-text-300 tw-normal-case tw-w-full tw-p-2 tw-h-10 tw-font-bold tw-mb-4" i18n="@@okayClose" (click)="showOrderSuccess()"> Okay, close </button>
      </div>
    </div>
  } @else {
    <div id="orderSuccessUI" data-testid="order-success" class="tw-flex tw-flex-col tw-h-full tw-bg-teal-500 tw-bg-repeat-x tw-bg-top tw-overflow-auto"
       [ngClass]="{
      'tw-bg-gray-100': isFraudAccordionOpen ,
      'tw-bg-teal-500 tw-bg-repeat-x tw-bg-top': !isFraudAccordionOpen,
    }"
      >
      @if (!isFraudAccordionOpen) {
        <div id="backButton" class="tw-fixed tw-left-4 tw-top-4 tw-z-10 tw-flex tw-items-center tw-justify-center tw-bg-gray-800 tw-rounded-xl tw-h-10 tw-w-10" (click)="handleBackPress()">
          <cs-icon class="tw-h-6 tw-w-6 tw-text-white" [iconName]="'arrow_back'"></cs-icon>
        </div>
        @if (!acquisitionRegimenOrderCheckupUI && !showVideoCallBanner) {
          @if (isConsulationOrder) {
            <header class="tw-flex-1 tw-flex tw-items-end tw-justify-center tw-px-10 tw-pt-16">
              <div class="tw-text-[16px] tw-font-body tw-font-bold tw-text-white tw-text-600 tw-text-center" i18n="@@hiUser">Hi {{ user?.get("PatientName")?.split(" ")[0] }},</div>
            </header>
          }
          @if (!isConsulationOrder) {
            <header class="tw-flex-1  tw-flex tw-items-end tw-justify-center tw-px-10 tw-pt-16"
                  [ngClass]="{
          'tw-overflow-visible tw-pb-[22px]': extraBannersExperiment ,
          'tw-pb-10': !extraBannersExperiment
        }"
              >
              @if (isIsotretinoinRemoval) {
                <div class="tw-flex tw-flex-col tw-items-center tw-gap-2 tw-pb-4">
                  <cs-icon class="tw-h-14 tw-w-14 tw-text-teal-600" [iconName]="'circle_tick_filled'"></cs-icon>
                  <div class="tw-text-gray-75 tw-text-center tw-font-lexend tw-font-bold tw-text-700" i18n="@@treatmentUpdatedTitle">
                We've updated your treatment
              </div>
                </div>
              }
              @if (!isIsotretinoinRemoval) {
                <div class="tw-text-gray-75 tw-text-center" i18n="@@orderConfirmed"
                 [ngClass]="{
                 'tw-text-700': ['ta', 'te', 'ml', 'kn'].includes(user?.get('languagePreference')),
                 'tw-text-800': !(['ta', 'te', 'ml', 'kn'].includes(user?.get('languagePreference'))),
                 'tw-font-body tw-font-bold': !extraBannersExperiment,
                 'tw-font-lexend tw-font-[700] tw-leading-[33px]': extraBannersExperiment,
                 }"> Your order is confirmed </div>
              }
            </header>
          }
          @if (isConsulationOrder) {
            <header class="tw-flex-1 tw-flex tw-items-end tw-justify-center tw-px-10 tw-pb-[140px]">
              <div class=" tw-text-[24px] tw-font-body tw-font-bold tw-text-gray-75 tw-text-800 tw-text-center" i18n="@@consultationOrderConfirmed" id="consultationOrderConfirmedTitle" [ngClass]="{'tw-text-700': ['ta', 'te', 'ml', 'kn'].includes(user?.get('languagePreference')), 'tw-text-800': !(['ta', 'te', 'ml', 'kn'].includes(user?.get('languagePreference')))}"> Your purchase is confirmed </div>
            </header>
          }
        }
        @if (acquisitionRegimenOrderCheckupUI || showVideoCallBanner) {
          <div class="tw-pt-[54px] tw-pb-[37px] tw-w-[227px] tw-mx-auto">
            <img class="tw-w-[58px] tw-aspect-square tw-mx-auto" src="/assets/gifs/tick-animation-teal.gif" />
            <p class="tw-text-center tw-text-400 tw-font-[700] tw-font-lexend tw-text-white" i18n="@@orderConfirmedCheckup">Order Confirmed</p>
            <div class="tw-bg-white tw-h-[1px] tw-w-full tw-opacity-20 tw-relative tw-my-4"></div>
            <!--          Expected delivery dynamic text for checkup-->
            @if (isEnglishOrHindiUser) {
              <div class="tw-text-white">
                <ng-container *ngTemplateOutlet="expectedDeliveryDateContent; context: { dateRangeClasses: 'tw-mt-[6.5] tw-font-lexend tw-font-[700] tw-text-white', textColorClass: 'tw-text-white' }"></ng-container>
              </div>
            } @else {
              <div class="tw-flex-1 tw-text-white">
                <ng-container *ngTemplateOutlet="deliveryMessageWithOn"></ng-container>
                @if (!expectedDeliveryDate.to && !expectedDeliveryDate.from) {
                  <div class="tw-flex tw-justify-center tw-items-center tw-pr-3">
                    <loading class="tw-scale-75"></loading>
                  </div>
                }
                @if (expectedDeliveryDate.to && expectedDeliveryDate.from) {
                  <p class="tw-font-body tw-font-bold tw-text-600 tw-text-center">
                    {{expectedDeliveryDate.from | date: 'd MMM' }} - {{expectedDeliveryDate.to | date: 'd MMM'}}
                  </p>
                }
              </div>
            }
          </div>
        }
      }
      <section  class="tw-rounded-tr-2xl tw-rounded-tl-2xl tw-flex-1 tw-flex tw-flex-col">
        <!--      parcel animation container (default — shown when neither video call nor checkup banner is active) -->
        @if (!isConsulationOrder && !isFraudAccordionOpen && !acquisitionRegimenOrderCheckupUI && !showVideoCallBanner) {
          <section class="tw-flex-none tw-flex tw-flex-col tw-items-center tw-justify-center tw-bg-white tw-rounded-tr-2xl tw-rounded-tl-2xl tw-px-6"
               [ngClass]="{
        'tw-pb-12': !extraBannersExperiment,
        'tw-pb-[46px]': extraBannersExperiment,
      }"
            >
            <!--          order success box gif-->
            <div class="tw-flex tw-items-center tw-justify-between">
              @if (!extraBannersExperiment) {
                <img src="/assets/images/paypment-sccess.gif" class="first:tw-w-[150px]" [width]='(showSurpriseGift$ | async) ? "150px" : "200px"' />
              }
              @if (extraBannersExperiment) {
                <img src="/assets/gifs/order-confirmed-teal.gif" class="first:tw-w-[150px]" [width]='(showSurpriseGift$ | async) ? "150px" : "200px"' />
              }
              @if ((showSurpriseGift$ | async)) {
                <div class="tw-text-800 tw-font-semibold tw-my-0 tw-mx-6">+</div>
              }
              @if ((showSurpriseGift$ | async)) {
                <img class="tw-w-15 tw-mb-4 tw-animate-gift_rotate tw-drop-shadow-z1" src="/assets/images/gift-box.svg" />
              }
            </div>
            @if ((showSurpriseGift$ | async)) {
              <p id="freeGift" class="tw-font-body tw-text-300 tw-text-gray-800 tw-px-12 tw-text-center" i18n="@@findAFreeGiftInside"> Find a free gift inside your Cure kit. </p>
            }
            <!--          Expected delivery dynamic text -->
            @if (isEnglishOrHindiUser) {
              <div id="dynamic-expected-delivery-date" class="tw-text-gray-800">
                <ng-container *ngTemplateOutlet="expectedDeliveryDateContent; context: { dateRangeClasses: extraBannersExperiment ? 'tw-text-gray-800 tw-mt-[6.5] tw-font-lexend tw-font-[700]' : 'tw-text-gray-800 tw-mt-4 tw-font-body tw-font-bold' }"></ng-container>
              </div>
            } @else {
              <div id="static-expected-delivery-date" class="tw-flex-1 tw-text-gray-800">
                <ng-container *ngTemplateOutlet="deliveryMessageWithOn"></ng-container>
                @if (!expectedDeliveryDate.to && !expectedDeliveryDate.from) {
                  <div class="tw-flex tw-justify-center tw-items-center tw-pr-3">
                    <loading class="tw-scale-75"></loading>
                  </div>
                }
                @if (expectedDeliveryDate.to && expectedDeliveryDate.from) {
                  <p id="expected-delivery-date" class="tw-font-body tw-font-bold tw-text-600 tw-text-black tw-text-center">
                    {{expectedDeliveryDate.from | date: 'd MMM' }} - {{expectedDeliveryDate.to | date: 'd MMM'}}
                  </p>
                }
              </div>
            }
            <!-- View Updated Treatment CTA for isotretinoin removal flow -->
            @if (isIsotretinoinRemoval) {
              <div class="tw-w-full tw-mt-6">
                <div class="tw-bg-teal-600 tw-rounded-3 tw-h-12 tw-flex tw-items-center tw-justify-center tw-cursor-pointer"
                  (click)="navigateToFaceRegimen()">
                  <span class="tw-font-lexend tw-font-semibold tw-text-500 tw-text-white" i18n="@@viewUpdatedTreatment">
                  View Updated Treatment
                </span>
                </div>
              </div>
            }
          </section>
        }
        @if (isConsulationOrder && !isFraudAccordionOpen) {
          <section class="tw-flex-none tw-flex tw-flex-col tw-items-center tw-justify-center tw-px-4 tw-pb-4 tw-bg-white tw-rounded-tr-2xl tw-rounded-tl-2xl">
            <div class="tw-p-4 tw-py-10 -tw-mt-[35%] tw-bg-teal-100 tw-items-center  tw-rounded-2xl">
              <div class="tw-flex tw-flex-col tw-items-center tw-justify-center">
                <cs-icon class="tw-w-[68px]"
                [iconName]="'call'"></cs-icon>
              </div>
              <div class="tw-flex tw-items-center tw-justify-between tw-text-center">
                <p class="tw-font-display tw-p-4 tw-px-14 tw-text-[22px] tw-text-400 tw-leading-8  tw-mt-4" id="consultationOrderContent" i18n="@@consultationOrderContent"> You will receive a call from our diet specialist shortly. </p>
              </div>
            </div>
          </section>
        }
        <!--      checkup banner -->
        @if (!isConsulationOrder && !isFraudAccordionOpen && acquisitionRegimenOrderCheckupUI) {
          <section class="tw-flex-none tw-flex tw-flex-col tw-items-center tw-justify-center tw-px-4 tw-pb-[21px] tw-pt-[37px] tw-bg-gray-75 tw-rounded-t-5" (click)="goToCheckupPage()">
            <div class="tw-bg-gray-80 tw-w-full tw-rounded-2.5 tw-relative tw-flex tw-justify-between">
              <div class="tw-pl-3">
                <div class="tw-bg-orange-100 tw-px-2.5 tw-pt-[3px] tw-pb-[2px] tw-rounded-b-[5px] tw-w-max tw-flex tw-justify-between tw-gap-[5px] tw-items-end tw-h-[19px] tw-mb-[22px]">
                  <span class="tw-uppercase tw-text-orange-400 tw-font-lexend tw-font-[700] tw-text-200 tw-tracking-[10%] tw-leading-[14px] tw-mb-[1px]">●</span>
                  <span class="tw-uppercase tw-text-orange-400 tw-font-lexend tw-font-[700] tw-text-50 tw-leading-[14px] tw-tracking-wide" i18n="@@importantLabel">important</span>
                </div>
                <div class="tw-mb-3">
                  <p>
                    <span class="tw-font-lexend tw-font-[700] tw-text-400 tw-leading-[8px] tw-mr-1" i18n="@@doctorCheckupScheduled">Doctor Check-up scheduled:</span>
                    <span class="tw-font-lexend  tw-text-400 tw-font-[400] tw-leading-[8px]" i18n="@@after2Weeks">After 2 weeks</span>
                    <span class="tw-font-lexend  tw-text-200 tw-font-[300] tw-block" i18n="@@withDoctorName">with {{allocatedDoctor?.DoctorDisplayName?.split(' ')?.slice(0,2)?.join(' ')}}</span>
                  </p>
                </div>
                <div class="tw-bg-gray-900 tw-h-[1px] tw-w-full tw-opacity-10 tw-relative tw-mb-3"></div>
                <div>
                  <span class="tw-font-lexend tw-font-[600] tw-text-200 tw-text-teal-600 tw-mr-1" i18n="@@learnMoreCheckup">Learn more</span>
                  <img src="/assets/icons/chevron_right_teal_rounded.svg" alt="learn more" class="tw-aspect-square tw-w-3 tw-inline-block"/>
                </div>
              </div>
              <img src="/assets/images/doc_checkup.png" alt="checkup" class="tw-h-auto tw-w-[119px]"/>
            </div>
          </section>
        }
        <!--      video call banner -->
        @if (!isConsulationOrder && !isFraudAccordionOpen && showVideoCallBanner) {
          <section class="tw-flex-none tw-flex tw-flex-col tw-items-center tw-justify-center tw-px-4 tw-pb-[21px] tw-pt-[37px] tw-bg-gray-75 tw-rounded-t-5" (click)="onVideoCallBannerClick()">
            <div class="tw-bg-gray-80 tw-w-full tw-rounded-2.5 tw-relative tw-flex tw-justify-between">
              <div class="tw-pl-3">
                <div class="tw-bg-orange-100 tw-px-2.5 tw-pt-[3px] tw-pb-[2px] tw-rounded-b-[5px] tw-w-max tw-flex tw-justify-between tw-gap-[3px] tw-items-end tw-h-[19px] tw-mb-[29px]">
                  <span class="tw-uppercase tw-text-orange-400 tw-font-lexend tw-font-[700] tw-text-300 tw-tracking-[0.8px] tw-leading-[14px] tw-mb-[1px]">●</span>
                  <span class="tw-uppercase tw-text-orange-400 tw-font-lexend tw-font-[700] tw-text-50 tw-leading-[14px] tw-tracking-[0.8px]" i18n="@@importantLabel">important</span>
                </div>
                <div class="tw-mb-3">
                  <p class="tw-font-lexend tw-font-[700] tw-text-400 tw-leading-[20px] tw-max-w-[145px]" i18n="@@doctorVideoCallBooked">Doctor Video Call Booked</p>
                  <p class="tw-font-lexend tw-text-200 tw-font-[300] tw-mt-2 tw-leading-[14px] tw-max-w-[167px]" i18n="@@videoCallScheduleDescription">We will call you to schedule the appointment at a convenient time.</p>
                </div>
              </div>
              @if (isFemaleUser) {
                <img src="/assets/images/video-call-doctor-female.png" alt="video call"
                  class="tw-h-auto tw-w-[135px] tw-flex-shrink-0"/>
              } @else {
                <img src="/assets/images/video-call-doctor-male.png" alt="video call"
                  class="tw-h-auto tw-w-[135px] tw-flex-shrink-0"/>
              }
            </div>
          </section>
        }
        <footer class="tw-flex-1 tw-flex tw-flex-col tw-pb-12 tw-bg-gray-80"
              [ngClass]="{
        'tw-p-6 tw-gap-3': !extraBannersExperiment,
        'tw-p-[22px] tw-px-4 tw-gap-4': extraBannersExperiment,
      }"
          >
          <!-- WhatsApp Banner -->
          @if (shouldShowWhatsappBannerUI) {
            <div id="whatsappBanner" class="tw-relative tw-bg-gradient-green-to-light-green tw-rounded-3 tw-overflow-hidden tw-shadow-z13" (click)="openWhatsAppChannel()">
              <div class="tw-flex tw-flex-col tw-p-4 tw-bg-green-50 tw-rounded-3">
                <p class="tw-font-body tw-font-normal tw-text-300 tw-text-gray-800" i18n="@@whatsappDailyTips">Get daily tips & doctor advice to <br/> improve your results faster</p>
              </div>
              <div class="tw-rounded-2 tw-py-1 tw-pb-1.5 tw-px-4">
                <p class="tw-font-lexend tw-font-semibold tw-text-200 tw-text-white" i18n="@@followCureskinWhatsapp">Follow Cure on <span class="tw-font-[900]">Whatsapp</span></p>
              </div>
              <img src="/assets/images/whatsapp.png" alt="WhatsApp" class="tw-absolute tw-right-[13px] tw-bottom-[5px] tw-w-[84px] tw-aspect-square tw-object-contain" />
            </div>
          }
          <!--        order confirmed UI when accordion is opened-->
          @if (isFraudAccordionOpen) {
            <div class="tw-p-2 tw-pr-4 tw-pl-3 tw-bg-teal-500 tw-rounded-2.5 tw-flex tw-items-center">
              <div>
                <img src="/assets/gifs/tick_animation.gif" alt="order confirmed" class="tw-w-12 tw-aspect-square tw-flex-shrink-0 " />
              </div>
              <p class="tw-font-bold tw-font-lexend tw-text-400 tw-text-white" i18n="@@orderConfirmed"> Your order is confirmed </p>
            </div>
          }
          <!-- Fraud Warning Banner -->
          @if (showFraudBanner) {
            <div id="fraudBanner"
             [ngClass]="{
        'tw-rounded-5 tw-shadow-z13': !isFraudAccordionOpen,
        'tw-rounded-4 tw-mb-12': isFraudAccordionOpen,
      }">
              <!-- Collapsed State -->
              @if (!isFraudAccordionOpen) {
                <div class="tw-flex tw-items-center tw-px-4 tw-py-[9.5px] tw-bg-orange-25 tw-rounded-4" (click)="openFraudAccordion()">
                  <div class="tw-flex-1">
                    <div class="tw-flex tw-items-end tw-gap-1.5">
                      <img src="/assets/icons/warning.png" alt="Warning" class="tw-w-4 tw-aspect-square tw-flex-shrink-0 tw-mb-1 " />
                      <p class="tw-font-lexend tw-font-bold tw-text-300 tw-text-gray-800" i18n="@@bewareOfFraudCalls">Beware of Fraud Calls</p>
                    </div>
                    <p class="tw-font-body tw-text-200 tw-text-gray-800 tw-font-normal" i18n="@@neverCallForPayments">We never call customers to ask for payments.</p>
                  </div>
                  <img src="/assets/icons/chevron-rounded-teal-top.png" alt="chevron" class="tw-w-3 tw-h-3 tw-flex-shrink-0" />
                </div>
              }
              <!-- Expanded State -->
              @if (isFraudAccordionOpen) {
                <div>
                  <!--            header -->
                  <div class="tw-flex tw-items-center tw-px-4 tw-py-[9.5px] tw-bg-orange-100 tw-rounded-t-4" (click)="closeFraudAccordion()">
                    <div class="tw-flex-1 tw-flex tw-items-end tw-gap-1.5">
                      <img src="/assets/icons/warning.png" alt="Warning" class="tw-w-5 tw-aspect-square tw-flex-shrink-0 tw-mb-1 " />
                      <p class="tw-font-lexend tw-font-bold tw-text-300 tw-text-gray-800" i18n="@@bewareOfFraudCalls">Beware of Fraud Calls</p>
                    </div>
                    <img src="/assets/icons/chevron-rounded-teal-top.png" alt="chevron" class="tw-w-3 tw-h-3 tw-flex-shrink-0 tw-rotate-180" />
                  </div>
                  <!--            content-->
                  <div class="tw-bg-white tw-rounded-b-4 tw-p-4">
                    <p class="tw-font-body tw-text-300 tw-text-gray-800 tw-mb-4 tw-font-semibold tw-leading-[18px]" i18n="@@neverCallToDemandPayment">Cure and our delivery partners will never call to demand payment or block your order for money.</p>
                    <div class="tw-border tw-border-gray-200 tw-rounded-2 tw-overflow-hidden tw-mb-6">
                      <div class="tw-flex tw-border-b tw-border-gray-200">
                        <div class="tw-bg-gray-100 tw-px-3 tw-py-2.5 tw-font-body tw-font-bold tw-text-200 tw-text-gray-800 tw-w-1/3" i18n="@@prepaidOrders">PREPAID ORDERS</div>
                        <div class="tw-px-3 tw-py-2.5 tw-font-body tw-text-200 tw-text-gray-800 tw-flex-1 tw-leading-tight" i18n="@@noExtraPaymentNeeded">No extra payment is <br/> needed.</div>
                      </div>
                      <div class="tw-flex">
                        <div class="tw-bg-gray-100 tw-px-3 tw-py-2.5 tw-font-body tw-font-bold tw-text-200 tw-text-gray-800 tw-w-1/3" i18n="@@codOrders">COD ORDERS</div>
                        <div class="tw-px-3 tw-py-2.5 tw-font-body tw-text-200 tw-text-gray-800 tw-flex-1 tw-leading-tight" i18n="@@payCashOnlyToAgent">Pay cash only to the delivery agent when the package arrives at your address. Do not make payment on call.</div>
                      </div>
                    </div>
                    <p class="tw-font-body tw-text-300 tw-text-orange-400 tw-mb-[11px]" i18n="@@scammersMayMentionAddress">Scammers may mention your address and pincode to trick you.</p>
                    <div class="tw-flex tw-flex-col tw-gap-3 tw-mb-3">
                      <div class="tw-flex tw-items-start tw-gap-2">
                        <img src="/assets/icons/cross-red.png" alt="chevron" class="tw-w-4 tw-aspect-square tw-flex-shrink-0 tw-mt-1" />
                        <p class="tw-font-body tw-text-300 tw-text-gray-800 tw-flex-1 tw-leading-[16px] tw-font-[400] tw-tracking-normal" i18n="@@doNotPayThroughLink">Do not pay through any link, UPI, GPay, Phonepe, QR code or bank transfer outside the Cure app.</p>
                      </div>
                      <div class="tw-flex tw-items-start tw-gap-2">
                        <img src="/assets/icons/cross-red.png" alt="chevron" class="tw-w-4 tw-aspect-square tw-flex-shrink-0 tw-mt-1" />
                        <p class="tw-font-body tw-text-300 tw-text-gray-800 tw-flex-1 tw-leading-[16px] tw-font-[400] tw-tracking-normal" i18n="@@doNotInstallApps">Do not install any apps like games, courier apps, etc.</p>
                      </div>
                    </div>
                    <div class="tw-pt-3 tw-border-t tw-border-gray-200 tw-leading-tight">
                      <p class="tw-font-body tw-text-300 tw-text-gray-800" i18n="@@ifYouGetSuspiciousCall">If you get a suspicious call,</p>
                      <p class="tw-font-bold tw-font-body tw-text-300 tw-text-gray-800">
                        <span i18n="@@fraudBannerCallUs">call us:</span>
                        <a href="tel:+918150096500" class="tw-font-bold tw-text-black tw-ml-0.5">+91 8150096500</a>
                      </p>
                      <p class="tw-font-body tw-text-300 tw-text-gray-800">
                        <span i18n="@@orEmailUs">or email us:</span>
                        <a href="mailto:hello@cureskin.com" class="tw-text-black tw-ml-0.5">hello&#64;cureskin.com</a>
                      </p>
                    </div>
                  </div>
                </div>
              }
            </div>
          }
          <!-- Explore Banner -->
          @if (shouldShowExploreBannerUI) {
            <div id="redirectToExplorePage"
              class="tw-flex tw-flex-wrap tw-gap-2 tw-items-center tw-bg-gray-75 tw-rounded-2"
               [ngClass]="{
          'tw-rounded-2 tw-py-2 tw-pl-6 tw-pr-2 tw-shadow-[0px_2px_4px_0px_rgba(0,0,0,0.1)]': !extraBannersExperiment,
          'tw-rounded-4 tw-px-4 tw-py-[9.5px] tw-shadow-z13 ': extraBannersExperiment,
        }"
              (click)="navigateToExplore()">
              <div class="tw-flex-1 tw-flex tw-flex-col tw-items-start">
                <p class="tw-font-body tw-font-bold tw-text-300 tw-text-gray-800" i18n="@@receiveTips">
                Receive expert tips
                <span class="tw-block tw-font-normal tw-font-body tw-text-300 tw-text-gray-800">
                  on skin & hair care
                </span>
              </p>
              </div>
              <div class="tw-flex tw-flex-row tw-items-center tw-gap-2 tw-h-8 tw-px-4 tw-bg-teal-500"
                 [ngClass]="{
                  'tw-rounded-full': !extraBannersExperiment,
                  'tw-rounded-2': extraBannersExperiment,
                }"
                >
                <div class="tw-font-lexend tw-font-bold tw-text-200 tw-text-white tw-capitalize"
                i18n="@@clickHere">Click Here</div>
                <cs-icon class="tw-h-4 tw-w-4 tw-text-white" [iconName]="'chevron_right'"></cs-icon>
              </div>
            </div>
          }
          <!-- Referral Banner -->
          @if (shouldShowReferralBannerUI) {
            <div id="redirectToUserWallet"
              class="tw-flex tw-flex-wrap tw-gap-2 tw-items-center tw-bg-gray-75"
                 [ngClass]="{
                  'tw-rounded-2 tw-py-2 tw-pl-6 tw-pr-2': !extraBannersExperiment,
                  'tw-rounded-4 tw-px-4 tw-py-[9.5px] tw-shadow-z13': extraBannersExperiment,
                }"
              (click)="navigateToReferral()">
              <div class="tw-flex-1 tw-flex tw-flex-col tw-items-start">
                <p class="tw-font-body tw-font-bold tw-text-300 tw-text-gray-800" i18n="@@referralCash">
                  Earn ₹{{referralCashValue$ | async}}
                  <span class="tw-block tw-font-normal tw-font-body tw-text-300 tw-text-gray-800">
                  Cure cash
                </span>
                </p>
              </div>
              <div class="tw-flex tw-flex-row tw-items-center tw-gap-2 tw-h-8 tw-px-4 tw-bg-teal-500"
                   [ngClass]="{
                  'tw-rounded-full': !extraBannersExperiment,
                  'tw-rounded-2': extraBannersExperiment,
                }"
                >
                <div class="tw-font-lexend tw-font-bold tw-text-200 tw-text-white tw-capitalize"
                i18n="@@referNow">Refer Now</div>
                <cs-icon class="tw-h-4 tw-w-4 tw-text-white" [iconName]="'chevron_right'"></cs-icon>
              </div>
            </div>
          }
        </footer>
      </section>
    </div>
    <!-- CTA for the expanded accordion of fraud banner -->
    @if (isFraudAccordionOpen && extraBannersExperiment) {
      <div class="tw-fixed tw-bottom-0 tw-right-0 tw-left-0 tw-shadow-z14 tw-p-4 tw-bg-white">
        <div class="tw-w-full tw-bg-teal-600 tw-text-white tw-font-lexend tw-font-semibold tw-text-400 tw-py-[9.5px] tw-px-4 tw-rounded-2 tw-text-center"
        (click)="closeFraudAccordion()" i18n="@@okayCaps">Okay</div>
      </div>
    }
    <!-- Template definitions -->
    <ng-template #treatmentKitExpectedToBeDelivered>
      <p [class]="(extraBannersExperiment || showVideoCallBanner) ? 'tw-font-lexend tw-text-300 tw-font-medium tw-mt-[8.3px] tw-text-center' : 'tw-font-body tw-text-300 tw-text-gray-800 tw-font-normal tw-mt-4 tw-text-center'" i18n="@@treatmentKitExpectedToBeDelivered"> Your treatment kit is expected <br/> to be delivered </p>
    </ng-template>
    <ng-template #treatmentKitExpectedDelivery>
      <p [class]="(extraBannersExperiment || showVideoCallBanner) ? 'tw-font-lexend tw-text-300 tw-font-medium tw-mt-[8.3px] tw-text-center' : 'tw-font-body tw-text-300 tw-text-gray-800 tw-font-normal tw-mt-4 tw-text-center'" i18n="@@treatmentKitExpectedDelivery"> Your treatment kit is expected <br/> to be delivered on </p>
    </ng-template>
    <ng-template #expectedToBeDelivered>
      <p [class]="(extraBannersExperiment || showVideoCallBanner) ? 'tw-font-lexend tw-text-300 tw-font-medium tw-mt-[8.3px] tw-text-center tw-max-w-48' : 'tw-font-body tw-text-300 tw-text-gray-800 tw-font-normal tw-mt-4 tw-text-center'" i18n="@@expectedToBeDelivered"> Your order is expected to be delivered  </p>
    </ng-template>
    <ng-template #youWillReceiveOn>
      <p [class]="(extraBannersExperiment || showVideoCallBanner) ? 'tw-font-lexend tw-text-300 tw-font-medium tw-mt-[8.3px] tw-text-center tw-max-w-48' : 'tw-font-body tw-text-300 tw-text-gray-800 tw-font-normal tw-mt-4 tw-text-center'" i18n="@@youWillReceiveOn"> Your order is expected to be delivered on </p>
    </ng-template>
    <ng-template #deliveryMessageWithoutOn>
      @if (isRegimenOrder) {
        <ng-container *ngTemplateOutlet="treatmentKitExpectedToBeDelivered"></ng-container>
      } @else {
        <ng-container *ngTemplateOutlet="expectedToBeDelivered"></ng-container>
      }
    </ng-template>
    <ng-template #deliveryMessageWithOn>
      @if (isRegimenOrder) {
        <ng-container *ngTemplateOutlet="treatmentKitExpectedDelivery"></ng-container>
      } @else {
        <ng-container *ngTemplateOutlet="youWillReceiveOn"></ng-container>
      }
    </ng-template>
    <ng-template #loadingState>
      @if (!expectedDeliveryDate.to && !expectedDeliveryDate.from) {
        <loading class="tw-mt-2.5"></loading>
      }
    </ng-template>
    <ng-template #expectedDeliveryDateContent let-dateRangeClasses="dateRangeClasses" let-textColorClass="textColorClass">
      <div class="tw-flex-1">
        @if (orderDeliveryDateToCurrentDateDifference <= 3) {
          <ng-container *ngTemplateOutlet="deliveryMessageWithoutOn"></ng-container>
        }
        @if (orderDeliveryDateToCurrentDateDifference > 3) {
          <ng-container *ngTemplateOutlet="deliveryMessageWithOn"></ng-container>
        }
        <ng-container *ngTemplateOutlet="loadingState"></ng-container>
        @if (orderDeliveryDateToCurrentDateDifference <= 1 && orderDeliveryDateToCurrentDateDifference) {
          <p class="tw-font-body tw-font-bold tw-mt-4 tw-text-center tw-text-700" [ngClass]="textColorClass || 'tw-text-gray-800'" i18n="@@byTomorrow">
          by tomorrow
        </p>
        }
        @if (orderDeliveryDateToCurrentDateDifference === 2 && orderDeliveryDateToCurrentDateDifference) {
          <p class="tw-font-body tw-font-bold tw-mt-4 tw-text-center tw-text-700" [ngClass]="textColorClass || 'tw-text-gray-800'" i18n="@@within2Days">
          within 2 days
        </p>
        }
        @if (orderDeliveryDateToCurrentDateDifference === 3 && orderDeliveryDateToCurrentDateDifference) {
          <p class="tw-font-body tw-font-bold tw-mt-4 tw-text-center tw-text-700" [ngClass]="textColorClass || 'tw-text-gray-800'" i18n="@@within3Days">
          within 3 days
        </p>
        }
        @if (orderDeliveryDateToCurrentDateDifference > 3 && expectedDeliveryDate.to && expectedDeliveryDate.from) {
          <p class="tw-text-center tw-text-700" [ngClass]="dateRangeClasses">
            {{expectedDeliveryDate.from | date: 'd MMM' }} - {{expectedDeliveryDate.to | date: 'd MMM'}}
          </p>
        }
      </div>
    </ng-template>
  }
}
<!--finasteride consent UI-->

<!--order success UI-->
